<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h4>Fire Insurance</h4></app-anchor
	>
	<h4 class="flex-1">/ Edit Fire Insurance Company</h4>
</div>
<app-container type="dark" class="mt-2">
	<div>
		<app-create-company-side-form
			[minify]="false"
			(onSubmit)="_onSubmit($event)"
			(onCancel)="_onCancel()"
			[name]="fireInsuranceCompany?.name"
			[company]="fireInsuranceCompany"
		>
		</app-create-company-side-form>
	</div>
</app-container>
